import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { get, put } from "../services/apiClient";

export interface PlatformSettingsRow {
  id: string;
  supportEmail: string | null;
  supportPhone: string | null;
  supportWhatsapp: string | null;
  legalEmail: string | null;
  officeAddress: string | null;
  termsUrl: string | null;
  privacyUrl: string | null;
  aboutUrl: string | null;
  maintenanceMode: boolean;
  maintenanceMessageEn: string | null;
  maintenanceMessageMl: string | null;
  defaultCancellationWindowHours: number;
  defaultBookingAdvanceWindowDays: number;
  minBookingNoticeHours: number;
  showPrices: boolean;
  updatedAt?: string;
}

export type UpdatePlatformSettingsInput = Partial<
  Omit<PlatformSettingsRow, "id" | "updatedAt">
>;

const KEY = ["platform-settings"] as const;

export const usePlatformSettings = () =>
  useQuery<PlatformSettingsRow>({
    queryKey: KEY,
    queryFn: () => get<PlatformSettingsRow>("/platform-settings"),
  });

export const useUpdatePlatformSettings = () => {
  const qc = useQueryClient();
  return useMutation<PlatformSettingsRow, Error, UpdatePlatformSettingsInput>({
    mutationFn: (data) => put<PlatformSettingsRow>("/platform-settings", data),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
};
